import { Component, OnInit, Input } from '@angular/core';

const baseCaptchaUrl: string = "./api/v1/captcha";

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnInit {
    captchaUrl: string = baseCaptchaUrl;
    private _refreshOnInit = false;

    @Input()
    set refreshOnInit(value: boolean) {
        this._refreshOnInit = value;
        if (this._refreshOnInit) {
            this.refreshCaptcha();
        }
    }

    get refreshOnInit(): boolean {
        return this._refreshOnInit;
    }

    constructor() { }

    ngOnInit(): void { }

    public refreshCaptchaEvent(event: Event): void {
        this.refreshCaptcha();
    }

    public refreshCaptcha() {
        this.captchaUrl = baseCaptchaUrl + "?" + new Date().getTime();
    }
}
